export default __webpack_public_path__ + "static/media/cancel-black-icon.caaa410b.svg";